export const manualBookingGerman = {
  retry: 'Erneut prüfen',
  sendUnresolved: 'Ein Versandauftrag ist ungeklärt. Wiederholen prüft denselben Auftrag.',
  retrySend: 'Erneut prüfen',
  sendFailed: 'Der Versandauftrag wurde abgelehnt. Bitte die Angaben prüfen.',
  shareDescription:
    'Der neue Link wird hier einmalig angezeigt. Es wird keine E-Mail gesendet; bisherige Links bleiben gültig.',
  afterTitle: 'Was danach passiert',
  afterAvailability:
    'Die Nächte werden für verbundene Buchungsportale gesperrt; die Übertragung läuft im Hintergrund.',
  afterZero: 'Der Gesamtbetrag ist null; es wird keine Zahlung angefordert.',
  afterPaymentEmail: 'Die Zahlungsaufforderung wird an die angegebene E-Mail-Adresse beauftragt.',
  afterPaymentWaiting:
    'Die Zahlung wird vorbereitet. Für den E-Mail-Versand muss eine Adresse nachgetragen werden.',
  afterAccessZero: 'Der Check-in-Zugang ist ohne Zahlung möglich.',
  afterAccessPaid: 'Der Check-in-Zugang ist nach bestätigter Zahlung möglich.',
  afterList: 'Die Buchung steht in der Liste und im Kalender.',
  createUnknown:
    'Keine bestätigte Antwort. Der Ausgang ist unklar; bitte denselben Auftrag erneut prüfen.',
  createUnresolved:
    'Ein Anlageauftrag ist ungeklärt. Wir prüfen den vorhandenen Auftrag; für einen erneuten Versuch dieselben Angaben verwenden.',
  paymentLink: 'Buchung mit Zahlungslink',
  direct: 'Direkt eintragen ohne Zahlungslink',
  perNight: 'Pro Nacht',
  totalStay: 'Gesamter Aufenthalt',
  totalStayLabel: 'Gesamtaufenthalt',
  nightPrice: 'Preis pro Nacht',
  directInfo:
    'Bestätigte Buchung. Zahlung außerhalb von StayOn verwaltet. Keine automatische Rechnung oder Gastkommunikation.',
  guestHint: 'Pflicht: Name; E-Mail optional',
  emailOptional: 'E-Mail · optional',
  priceHint: 'Vereinbarter Unterkunftsbetrag, brutto. Enthaltene Reinigung nicht erneut addieren.',
  previewError: 'Preisvorschau nicht verfügbar. Bitte Verbindung prüfen und erneut versuchen.',
  previewLoading: 'Endsumme wird geprüft …',
  nights: '{{count}} Nächte',
  average: 'Durchschnitt',
  additional: ' · zusätzlich',
  total: 'Endsumme',
  averageNight: 'Durchschnitt pro Nacht',
  quiet:
    'Gastkommunikation ruht. Einen Link können Sie bewusst weitergeben oder einmalig per E-Mail senden.',
  guestEmail: 'E-Mail des Gastes',
  addEmail: 'E-Mail nachtragen',
  saveContact: 'Kontakt speichern',
  missingEmail: 'Für den Versand zuerst eine E-Mail-Adresse ergänzen.',
  recipient: 'Empfänger: {{email}}',
  queued: 'Check-in-E-Mail beauftragt. Keine weitere Mailserie aktiviert.',
  activeLink:
    'Ein bestehender Gastzugang ist an die bisherige Adresse gebunden. Der Empfänger wurde nicht geändert.',
  changedEmail: 'Die Adresse wurde inzwischen geändert. Bitte Empfänger neu prüfen.',
  unknown:
    'Keine bestätigte Antwort. Bitte erneut versuchen; derselbe Versandauftrag wird nicht doppelt angelegt.',
  send: 'Check-in-Link per E-Mail senden',
  sendTitle: 'Check-in-Link per E-Mail senden?',
  sendDescription:
    'Empfänger: {{email}}. Einmaliger Versand; eine ruhende Mailserie bleibt ausgeschaltet.',
  confirmSend: 'E-Mail senden',
};
export const manualBookingEnglish = {
  retry: 'Try again',
  sendUnresolved: 'A delivery request has an unknown outcome. Retry checks the same request.',
  retrySend: 'Check again',
  sendFailed: 'The delivery request was rejected. Please review the details.',
  shareDescription:
    'The new link is shown once here. No email is sent; existing links remain valid.',
  afterTitle: 'What happens next',
  afterAvailability:
    'Nights are blocked on connected booking channels; transmission runs in the background.',
  afterZero: 'The total is zero; no payment is requested.',
  afterPaymentEmail: 'A payment request is queued for the supplied email address.',
  afterPaymentWaiting: 'Payment is prepared. Add an email address for delivery.',
  afterAccessZero: 'Check-in access is available without payment.',
  afterAccessPaid: 'Check-in access is available after confirmed payment.',
  afterList: 'The booking appears in the list and calendar.',
  createUnknown:
    'No confirmed response. The outcome is unknown; please check the same request again.',
  createUnresolved:
    'A creation request is unresolved. We check the existing request; use the same details to retry.',
  paymentLink: 'Booking with payment link',
  direct: 'Enter directly without payment link',
  perNight: 'Per night',
  totalStay: 'Entire stay',
  totalStayLabel: 'Entire stay',
  nightPrice: 'Price per night',
  directInfo:
    'Confirmed booking. Payment is managed outside StayOn. No automatic invoice or guest communication.',
  guestHint: 'Required: name; email optional',
  emailOptional: 'Email · optional',
  priceHint: 'Agreed accommodation amount, gross. Do not add included cleaning again.',
  previewError: 'Price preview unavailable. Check the connection and try again.',
  previewLoading: 'Checking final total …',
  nights: '{{count}} nights',
  average: 'Average',
  additional: ' · additional',
  total: 'Final total',
  averageNight: 'Average per night',
  quiet: 'Guest communication is paused. You can share a link or send a one-time email.',
  guestEmail: 'Guest email',
  addEmail: 'Add email',
  saveContact: 'Save contact',
  missingEmail: 'Add an email address before sending.',
  recipient: 'Recipient: {{email}}',
  queued: 'Check-in email queued. No further email series was activated.',
  activeLink:
    'Existing guest access is bound to the previous address. The recipient was not changed.',
  changedEmail: 'The address has changed. Please review the recipient again.',
  unknown: 'No confirmed response. Try again; the same send request will not be duplicated.',
  send: 'Send check-in link by email',
  sendTitle: 'Send check-in link by email?',
  sendDescription: 'Recipient: {{email}}. One-time delivery; the paused email series remains off.',
  confirmSend: 'Send email',
};
